import React from "react"

import {hasProperty} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

class ViewCodeList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };

        this.dsd = new dsd();

        this.data = {};
        this.data.CodeList = null;

        if (this.props.CodeList){
            this.data.CodeList = this.props.CodeList;
        }
    }

    componentDidMount() {
        if (this.data.CodeList){
            this.setState({ isLoaded: true });
        }
    }

    view(json){

        if (!json) { return null; }

        return (
            <PD.Table className="panel">
                <PD.Tbody>

                    {hasProperty(json,'name') &&
                        <PD.Tr>
                            <PD.Th>Name</PD.Th>
                            <PD.Td><PD.PdNavLink to={`/codelist/${json._id}`}>{json.name}</PD.PdNavLink></PD.Td>
                        </PD.Tr>
                    }

                    {hasProperty(json,'description') &&
                        <PD.Tr>
                            <PD.Th>Description</PD.Th>
                            <PD.Td>
                                <PD.MdPresent>{json.description}</PD.MdPresent>
                            </PD.Td>
                        </PD.Tr>
                    }

                    {hasProperty(json,'namespace') &&
                        <PD.Tr>
                            <PD.Th>Namespace</PD.Th>
                            <PD.Td>{json.namespace}</PD.Td>
                        </PD.Tr>
                    }

                    {hasProperty(json,'prefix') &&
                        <PD.Tr>
                            <PD.Th>Default Prefix</PD.Th>
                            <PD.Td>{json.prefix}</PD.Td>
                        </PD.Tr>
                    }

                    {hasProperty(json,'proposals') &&
                        <PD.Tr>
                            <PD.Th>Proposals</PD.Th>
                            <PD.Td>
                                <PD.MdPresent>{json.proposals}</PD.MdPresent>
                            </PD.Td>
                        </PD.Tr>
                    }

                    {hasProperty(json,'status') &&
                        <PD.Tr>
                            <PD.Th>Status</PD.Th>
                            <PD.Td>{json.status}</PD.Td>
                        </PD.Tr>
                    }

                    {json.Owner &&
                        <PD.Tr>
                            <PD.Th>Owner</PD.Th><PD.Td>{json.Owner.organisation}</PD.Td>
                        </PD.Tr>
                    }
                    

                </PD.Tbody>
            </PD.Table>
        );
    }

    render() {

        if (this.state.isLoaded) {
            return (
                <div>
                    {this.view(this.data.CodeList)}
                </div>
            );
        }

        return <div />;
    }
}

export default ViewCodeList;
